import http from '@/helpers/http'
import { mountComponentTag } from '@/mounter'

import DotcomSystemNotifications from './SystemNotifications'

http.create({
  axiosConfig: {
    baseURL: '/',
  },
})

mountComponentTag('dotcom-system-notification', DotcomSystemNotifications)
